import { toWords } from 'number-to-words';

const formatCurrencyWords = (amount, currencyCode) => {
  const amountInWords = toWords(Math.floor(amount));
  return `${currencyCode} ${amountInWords.charAt(0).toUpperCase() + amountInWords.slice(1)}`;
};

export default formatCurrencyWords;
